import React, { Fragment } from 'react';

import {
  IdCell,
  LoadSummaryCell,
  WeightCell,
  HeightCell,
  ExtrasSummary,
  StartDateTimeCell,
  StatusCell,
} from 'modules/Common/Details';

const t = {
  header_id: 'Order Id',
  header_start_date_time: 'Start',
  header_pallets: 'Pallets',
  header_weight: 'Weight',
  header_height: 'Height',
  header_extras: 'Extras',
  header_status: 'Status',
};

const tableCellsConfig = [
  {
    props: {
      cellWidth: 84,
      mLeft: 'S',
    },
    header: t.header_id,
    children: ({ item }) =>
      item && (
        <Fragment>
          <IdCell id={item.id} idType="shipperorder" isFromRecurring={true} />
        </Fragment>
      ),
  },
  {
    props: {
      cellWidth: 128,
      textAlign: 'left',
    },
    header: t.header_start_date_time,
    children: ({ item }) => item && <StartDateTimeCell {...item} />,
  },
  {
    props: {
      cellWidth: 72,
      textAlign: 'center',
    },
    header: t.header_pallets,
    children: ({ item }) =>
      item && <LoadSummaryCell {...item} real_pallets={item.number_of_items} />,
  },
  {
    props: {
      cellWidth: 72,
      textAlign: 'center',
    },
    header: t.header_weight,
    children: ({ item }) => item && <WeightCell {...item} />,
  },
  {
    props: {
      cellWidth: 72,
      textAlign: 'center',
    },
    header: t.header_height,
    children: ({ item }) => item && <HeightCell {...item} showIcon={false} />,
  },
  {
    props: {
      cellWidth: 128,
      textAlign: 'left',
    },
    header: t.header_extras,
    children: ({ item }) => item && <ExtrasSummary {...item} small />,
  },
  {
    props: {
      cellWidth: 256,
      textAlign: 'left',
    },
    header: t.header_status,
    children: ({ item }) => item && <StatusCell {...item} />,
  },
];

export default tableCellsConfig;
